<script>
    const axios = require('axios');

    export default {

        data() {
            return {
                originalAddresses: []
            }
        },

        mounted() {
            axios.get('/profile/address')
                .then(data => {
                    this.originalAddresses = data.data;
                })
                .catch(function(e){if(e.code!=='ECONNABORTED'){throw e;}});
        },

        computed: {

            lastUsedAddress(){
                return this.originalAddresses[0] || null;
            },

            addresses(){
                return this.originalAddresses.slice(1);
            }

        },

        methods: {

            deleteAddress(index){
                this.originalAddresses.splice(index, 1);
            },

            addAddress(){
                this.originalAddresses.push({});
            }

        }
    }
</script>